import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { AgGridReact } from 'ag-grid-react';
import {
  Tab,
  Nav,
  Dropdown,
  Form,
  Col,
  Row,
  FormGroup,
  Card,
  Modal,
} from "react-bootstrap";
import { workerdetail, listsetting, academyusergetdetail } from "../../../services/admin";
import { salaryRegister, getPayslip } from "../../../services/payroll";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment/moment";

export default function Workersmyprofile() {
  const baseUrl = (localStorage.getItem("activeBaseUrl") || "").replace("/api", "");
  const { id } = useParams();
  const [wdetail, setWdetail] = useState('');
  const [pswd, setPswd] = useState('');
  const [wpath, setWpath] = useState('');
  const [qrpath, setQrPath] = useState('');
  const [tdetail, setTDetail] = useState('');
  const [rdetail, setRDetail] = useState([]);
  const [attdet, setAttdet] = useState('');

  const [fdate, setFDate] = useState('');
  const [tdate, setTDate] = useState('');

  const [certList, setCertList] = useState([]);
  const [headerUrl, setHeaderUrl] = useState("");
  const [footerUrl, setFooterUrl] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [schoolAddress, setSchoolAddress] = useState("");

  const [payslipList, setPayslipList]     = useState([]);
  const [payslipLoaded, setPayslipLoaded] = useState(false);
  const [payslip, setPayslip]             = useState(null);
  const [payslipShow, setPayslipShow]     = useState(false);
  const [school, setSchool]               = useState({ name: "", phone: "", address: "", logoUrl: "" });

  useEffect(() => {
    setFDate(moment(new Date()).format("YYYY-MM-DD"));
    setTDate(moment(new Date()).format("YYYY-MM-DD"));
    listall(moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"));
    academyusergetdetail(localStorage.getItem("UID")).then((res) => {
      if (res?.status) {
        const d = res.data.details;
        setSchool({ name: d.academy_name || "", phone: d.phone || "", address: d.address || "", logoUrl: d.logo ? (res.data.path + d.logo) : "" });
      }
    });
  }, []);

  function loadPayslips() {
    if (payslipLoaded) return;
    const empUserId = wdetail?.user_id;
    if (!empUserId) return;
    const temp = new FormData();
    temp.append("employee_id",   empUserId);
    temp.append("employee_type", "worker");
    if (localStorage.getItem("Role") === "1") temp.append("academy_id", localStorage.getItem("AAcademy") || "");
    salaryRegister(temp).then((res) => {
      if (res?.status) { setPayslipList(res.data.items || []); setPayslipLoaded(true); }
    });
  }

  function handleViewPayslip(itemId) {
    getPayslip(itemId).then((res) => {
      if (res?.status) { setPayslip(res.data); setPayslipShow(true); }
      else toast.error(res?.message || "Failed to load payslip");
    });
  }

  async function toBase64(url) {
    try { const r = await fetch(url); const b = await r.blob(); return new Promise((resolve) => { const rd = new FileReader(); rd.onloadend = () => resolve(rd.result); rd.readAsDataURL(b); }); }
    catch { return null; }
  }

  async function printPayslip() {
    if (!payslip) return;
    const MONTHS = ["","January","February","March","April","May","June","July","August","September","October","November","December"];
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const pageW = doc.internal.pageSize.getWidth();
    const month = `${MONTHS[payslip.payroll_month?.month]} ${payslip.payroll_month?.year}`;
    const primary = [45, 74, 198];
    doc.setFillColor(...primary); doc.rect(0, 0, pageW, 30, "F");
    if (school.logoUrl) { const b64 = await toBase64(school.logoUrl); if (b64) try { doc.addImage(b64, "PNG", 8, 4, 22, 22); } catch {} }
    doc.setTextColor(255, 255, 255); doc.setFontSize(15); doc.setFont(undefined, "bold");
    doc.text(school.name || "School", 34, 13);
    doc.setFontSize(8); doc.setFont(undefined, "normal");
    if (school.address) doc.text(school.address, 34, 19, { maxWidth: pageW - 50 });
    if (school.phone) doc.text(`Ph: ${school.phone}`, 34, 25);
    doc.setFontSize(14); doc.setFont(undefined, "bold"); doc.text("PAYSLIP", pageW - 10, 18, { align: "right" });
    doc.setFillColor(240, 243, 255); doc.rect(0, 30, pageW, 10, "F");
    doc.setTextColor(...primary); doc.setFontSize(10);
    doc.text(`Salary for the month of ${month}`, pageW / 2, 37, { align: "center" });
    doc.setTextColor(40, 40, 40); doc.setFontSize(9);
    const lX = 14, rX = pageW / 2 + 5; let y = 48;
    doc.setDrawColor(220, 220, 220); doc.setFillColor(250, 250, 252); doc.rect(10, 42, pageW - 20, 28, "FD");
    [["Employee Name", payslip.employee_name], ["Employee Code", payslip.employee_code], ["Employee Type", payslip.employee_type], ["Payment Month", month]]
      .forEach(([l, v], i) => { const ry = y + i * 6; doc.setFont(undefined, "bold"); doc.setTextColor(80, 80, 80); doc.text(l + ":", lX + 2, ry); doc.setFont(undefined, "normal"); doc.setTextColor(30, 30, 30); doc.text(v || "", lX + 40, ry); });
    [["Bank Name", payslip.bank_name || "—"], ["Account No", payslip.bank_accno || "—"], ["Working Days", String(payslip.total_days)], ["Present Days", String(payslip.present_days)]]
      .forEach(([l, v], i) => { const ry = y + i * 6; doc.setFont(undefined, "bold"); doc.setTextColor(80, 80, 80); doc.text(l + ":", rX + 2, ry); doc.setFont(undefined, "normal"); doc.setTextColor(30, 30, 30); doc.text(v || "", rX + 32, ry); });
    const earn = payslip.details?.filter((d) => d.component_type === "earning") || [];
    const dedu = payslip.details?.filter((d) => d.component_type === "deduction") || [];
    autoTable(doc, {
      startY: 76,
      head: [["Earnings", "Amount", "Deductions", "Amount"]],
      body: Array.from({ length: Math.max(earn.length, dedu.length) }, (_, i) => [earn[i]?.component_name || "", earn[i] ? `₹ ${parseFloat(earn[i].amount).toFixed(2)}` : "", dedu[i]?.component_name || "", dedu[i] ? `₹ ${parseFloat(dedu[i].amount).toFixed(2)}` : ""]),
      foot: [["Gross Salary", `₹ ${parseFloat(payslip.gross_salary).toFixed(2)}`, "Total Deductions", `₹ ${parseFloat(payslip.total_deductions).toFixed(2)}`]],
      headStyles: { fillColor: primary, textColor: 255, fontStyle: "bold", fontSize: 9 },
      footStyles: { fillColor: [230, 235, 255], textColor: primary, fontStyle: "bold", fontSize: 9 },
      bodyStyles: { fontSize: 8 }, alternateRowStyles: { fillColor: [248, 250, 255] },
      columnStyles: { 1: { halign: "right" }, 3: { halign: "right" } }, margin: { left: 10, right: 10 },
    });
    const finalY = doc.lastAutoTable.finalY + 6;
    doc.setFillColor(...primary); doc.roundedRect(10, finalY, pageW - 20, 12, 2, 2, "F");
    doc.setTextColor(255, 255, 255); doc.setFontSize(11); doc.setFont(undefined, "bold");
    doc.text("Net Salary Payable", 16, finalY + 8);
    doc.text(`₹ ${parseFloat(payslip.net_salary).toFixed(2)}`, pageW - 16, finalY + 8, { align: "right" });
    doc.save(`Payslip_${payslip.employee_name}_${month}.pdf`);
  }

  function listall(fdte, tdte) {
    setFDate(fdte);
    setTDate(tdte);
    workerdetail(id, fdte, tdte).then((res) => {
      if (res.status === true) {
        setWdetail(res.data.details);
        setPswd(res.data.password);
        setTDetail(res.data.transport);
        setWpath(res.data.path);
        setAttdet(res.data.attendance);
        setQrPath(res.data.qrpath);
        const sdata = res.data.route?.map((item) => {
          return { ...item, change_date: moment(item.change_date).format("DD-MM-YYYY") }
        })
        setRDetail(sdata);

        if (res.data.details) {
          if (res.data.certificates) setCertList(res.data.certificates);
          const aca = localStorage.getItem("AAcademy") || localStorage.getItem("academy") || "";
          const settTemp = new FormData();
          settTemp.append("academy_id", aca);
          listsetting(settTemp).then((resp) => {
            if (resp?.status && resp.data) {
              if (resp.data.certificate_header) setHeaderUrl(baseUrl + "/" + resp.data.certificate_header);
              if (resp.data.certificate_footer) setFooterUrl(baseUrl + "/" + resp.data.certificate_footer);
              setSchoolName(resp.data.school_name || "");
              setSchoolAddress(resp.data.address || "");
            }
          });
        }
      }
    })
  }
  const columnDefs = [
    {
      headerName: "Vehicle",
      field: "vehicle_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Route",
      field: "vehroute_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date",
      field: "change_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },

    },
    {
      headerName: "Remark",
      field: "remarks",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

  ];
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Worker Profile</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Worker</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Worker Profile
          </li>
        </ol>
      </div>
      <div className="main-container container-fluid">
        <div className="inner-body">
          <Tab.Container

            defaultActiveKey="first"
            className="bg-gray-100"
          >
            <Row className="square">
              <div className="col-lg-12 col-md-12">
                <Card className="custom-card">
                  <Card.Body>
                    <div className="panel profile-cover">
                      <div className="profile-cover__img">
                        <img
                          src={wdetail.worker_photo ? wpath + wdetail.worker_photo : require("../../../assets/images/user.png")}
                          alt="Student"
                        />
                        <h3 className="h3">{wdetail ? wdetail.worker_name : ''}</h3>
                      </div>


                      <div className="profile-cover__action bg-img"></div>
                      <div className="profile-cover__info">
                        <ul className="nav">
                          <li>
                            <strong>{wdetail ? wdetail.username : ''}</strong>Username
                          </li>
                          {localStorage.getItem("Role") < 3 && (
                            <li><strong>{pswd}</strong>Password</li>
                          )}
                          <li>
                            <strong>{wdetail ? wdetail.employee_id : ''}</strong>Employee ID
                          </li>
                          <li>
                            <strong>{wdetail ? wdetail.gender : ''}</strong>Gender
                          </li>
                        </ul>
                      </div>
                      <div className="profile-tab tab-menu-heading m">
                        <Nav
                          variant="pills"
                          className="p-3 bg-primary-transparent"
                        >
                          <Nav.Item>
                            <Nav.Link eventKey="first">Worker Detail</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="Transport">
                              Transport
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="Route">Route Change</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="Attendance">Attendance</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="Certificates">Certificates</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="Payslip" onClick={loadPayslips}>Payslip</Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Row>
            <Row className="row-sm">
              <Col md={12} lg={12}>
                <div className="card custom-card main-content-body-profile">
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <Row className="row-sm">
                        <Col md={12} lg={6}>

                          <div className="main-content-body tab-pane p-sm-4 p-0 border-top-0">
                            <div className="card-body border">
                              <Form className="form-horizontal">
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Name <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? wdetail.worker_name : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        DOB <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? moment(wdetail.dob).format('DD-MM-YYYY') : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Blood Group{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? wdetail.blood_name : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>

                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Phone No{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? wdetail.phone : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Qualification
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? wdetail.qualification : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>

                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        QR
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <img
                                        src={wdetail.qr_code !== null ? qrpath + wdetail.qr_code : require("../../../assets/images/user.png")}
                                        alt="QR Code"
                                      />
                                    </Col>
                                  </Row>
                                </FormGroup>
                              </Form>
                            </div>
                          </div>
                        </Col>
                        <Col md={12} lg={6}>

                          <div className="main-content-body tab-pane p-sm-4 p-0 border-top-0">
                            <div className="card-body border">
                              <Form className="form-horizontal">


                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Address 1{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? wdetail.address1 : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Address 2{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? wdetail.address2 : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        State <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? wdetail.state_name : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        District
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? wdetail.district : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        City <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? wdetail.city : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group mb-0">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Pin Code{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {wdetail ? wdetail.pincode : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                              </Form>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Transport">
                      <Row className="row-sm">
                        <Col md={6} lg={6}>

                          <div className="main-content-body tab-pane p-sm-4 p-0 border-top-0">
                            <div className="card-body border">

                              <Form className="form-horizontal">
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Vehicle Number{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {" "}
                                        {tdetail ? tdetail.vehicle_no : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Vehicle Registration Number{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {tdetail ? tdetail.reg_no : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        RC Number{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {tdetail ? tdetail.rc_no : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Chasis Number{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {tdetail ? tdetail.chasis_no : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>

                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Registration Date{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {tdetail ? moment(tdetail.reg_date).format('DD-MM-YYYY') : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Registration Renewal Date{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">{tdetail ? moment(tdetail.reg_renewal_date).format('DD-MM-YYYY') : ''}</h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Tax Start Date
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {tdetail ? moment(tdetail.tax_start_date).format('DD-MM-YYYY') : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Tax Renewal Date
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {tdetail ? moment(tdetail.tax_renewal_date).format('DD-MM-YYYY') : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>

                              </Form>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} lg={6}>

                          <div className="main-content-body tab-pane p-sm-4 p-0 border-top-0">
                            <div className="card-body border">

                              <Form className="form-horizontal">
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Vehicle Type{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {" "}
                                        {tdetail ? tdetail.vehtype_name : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Route Name{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {tdetail ? tdetail.vehroute_name : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Pollution Certification Number{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {tdetail ? tdetail.certificate_no : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        POC Start Date{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {tdetail ? moment(tdetail.pos_start_date).format('DD-MM-YYYY') : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        POC Renewal Date{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">{tdetail ? moment(tdetail.pos_renewal_date).format('DD-MM-YYYY') : ''}</h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Insurance Number{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">
                                        {tdetail ? tdetail.insurance_no : ''}
                                      </h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Insurance Start Date{" "}
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">{tdetail ? moment(tdetail.ins_start_date).format('DD-MM-YYYY') : ''}</h3>
                                    </Col>
                                  </Row>
                                </FormGroup>
                                <FormGroup className="form-group">
                                  <Row className="row-sm">
                                    <Col md={6} sm={4}>
                                      <h3 className="studentdetail-a">
                                        Insurance Renewal Date
                                        <span className="pull-end">:</span>
                                      </h3>
                                    </Col>
                                    <Col md={6} sm={8}>
                                      <h3 className="student-detail-b">{tdetail ? moment(tdetail.ins_renewal_date).format('DD-MM-YYYY') : ''}</h3>

                                    </Col>
                                  </Row>
                                </FormGroup>
                              </Form>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Route">
                      <div className="main-profile-body p-0">
                        <div className="ag-theme-alpine ag-style mt-2" style={{ height: rdetail.length > 10 ? "600px" : "auto" }}>
                          <AgGridReact
                            columnDefs={columnDefs}
                            rowData={rdetail}
                            pagination="true"
                            paginationPageSize="10"
                            sortingOrder={["asc", "desc"]}
                            suppressDragLeaveHidesColumns={true}
                            domLayout={rdetail.length < 10 ? "autoHeight" : '600px'}
                          />
                        </div>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Attendance">
                      <div className="row">
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              From Date<span className="text-danger"> *</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              value={fdate}
                              onChange={(e) => listall(e.target.value,tdate)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              To Date<span className="text-danger"> *</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              value={tdate}
                              onChange={(e) => setTDate(fdate,e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12 col-lg-12 col-xl-12">
                            <div className="row row-cards mt-1">
                              {/* <h5>{item.year}</h5> */}
                              <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">

                                  <div className="card bg-custom">
                                    <div className="card-body text-center feature">
                                      <p className="card-text mt-2">
                                        <strong>Total Days</strong>
                                      </p>
                                      <p className="h3 text-center text-info">{attdet.total_days}</p>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                  <div className="card bg-custom">
                                    <div className="card-body text-center feature">
                                      <p className="card-text mt-2">
                                        <strong>Total Present</strong>
                                      </p>
                                      <p className="h3 text-center text-success">{attdet.total_present_days}</p>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                  <div className="card bg-custom">
                                    <div className="card-body text-center feature">
                                      <p className="card-text mt-2">
                                        <strong>Total Absent</strong>
                                      </p>
                                      <p className="h3 text-center text-danger">{attdet.absent_days}</p>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                  <div className="card bg-custom">
                                    <div className="card-body text-center feature">
                                      <p className="card-text mt-2">
                                        <strong>Half day</strong>
                                      </p>
                                      <p className="h3 text-center text-warning">{attdet.half_day_present}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>

                        {attdet == "" &&
                          <div className="d-md-flex ms-auto mb-2">
                            <label className="my-auto pt-2 exam-title"><strong>No Attendance Found</strong></label>
                          </div>
                        }
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Certificates">
                      <div className="p-4">
                        {certList.length === 0 ? (
                          <div className="d-md-flex ms-auto mb-2">
                            <label className="my-auto pt-2 exam-title"><strong>No Certificates Generated Yet</strong></label>
                          </div>
                        ) : (
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover mb-0">
                              <thead style={{ backgroundColor: "#b0b0b0" }}>
                                <tr>
                                  <th>#</th>
                                  <th>Certificate Type</th>
                                  <th>Generated Date</th>
                                  <th>Total Generated</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {certList.map((cert, idx) => {
                                  const count = certList.filter(c => c.cert_type === cert.cert_type).length;
                                  return (
                                    <tr key={idx}>
                                      <td>{idx + 1}</td>
                                      <td>
                                        <i className="fa fa-certificate me-2" style={{ color: "#6259ca" }}></i>
                                        {cert.cert_label}
                                      </td>
                                      <td>{moment(cert.generated_date).format("DD-MM-YYYY")}</td>
                                      <td>
                                        <span className="badge bg-primary">{count} time{count !== 1 ? "s" : ""}</span>
                                      </td>
                                      <td className="d-flex gap-1">
                                        {cert.pdf_path && (
                                          <a
                                            className="btn btn-success btn-sm"
                                            href={cert.pdf_path.startsWith("http") ? cert.pdf_path : baseUrl + "/" + cert.pdf_path}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                          >
                                            <i className="fa fa-download me-1"></i> PDF
                                          </a>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="Payslip">
                      <div className="p-3">
                        {payslipList.length === 0 ? (
                          <div className="d-md-flex ms-auto mb-2">
                            <label className="my-auto pt-2 exam-title"><strong>No payslip records found</strong></label>
                          </div>
                        ) : (
                          <div className="row row-sm">
                            {payslipList.map((item) => (
                              <div key={item.id} className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="card" style={{ border: "1px solid #dee2e6", borderRadius: "8px", overflow: "hidden" }}>
                                  <div style={{ background: "#2d4ac6", padding: "10px 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{ color: "#fff", fontWeight: 600, fontSize: "14px" }}>{item.month_label}</span>
                                    <span className={`badge ${item.status === "paid" ? "bg-success" : item.status === "approved" ? "bg-primary" : "bg-secondary"}`}>
                                      {item.status}
                                    </span>
                                  </div>
                                  <div className="card-body p-3">
                                    <div className="d-flex justify-content-between mb-2">
                                      <span className="text-muted" style={{ fontSize: "12px" }}>Attendance</span>
                                      <span style={{ fontSize: "13px", fontWeight: 500 }}>{item.present_days} / {item.total_days} days</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                      <span className="text-muted" style={{ fontSize: "12px" }}>Gross Salary</span>
                                      <span style={{ fontSize: "13px" }}>₹ {parseFloat(item.gross_salary || 0).toFixed(2)}</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                      <span className="text-muted" style={{ fontSize: "12px" }}>Deductions</span>
                                      <span style={{ fontSize: "13px", color: "#dc3545" }}>- ₹ {parseFloat(item.total_deductions || 0).toFixed(2)}</span>
                                    </div>
                                    <hr className="my-2" />
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div>
                                        <div className="text-muted" style={{ fontSize: "11px" }}>Net Salary</div>
                                        <div style={{ fontSize: "16px", fontWeight: 700, color: "#145214" }}>₹ {parseFloat(item.net_salary || 0).toFixed(2)}</div>
                                      </div>
                                      <a onClick={() => handleViewPayslip(item.id)} className="btn btn-sm btn-info">
                                        <i className="fa fa-file-pdf-o me-1" /> View
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </Tab.Pane>

                  </Tab.Content>
                </div>
              </Col>
            </Row>
          </Tab.Container>

          {/* Payslip Modal */}
          <Modal show={payslipShow} onHide={() => setPayslipShow(false)} size="lg">
            <Modal.Header><h4>Payslip — {payslip?.employee_name}</h4></Modal.Header>
            <Modal.Body>
              {payslip && (
                <div style={{ border: "1px solid #dee2e6", borderRadius: "6px", overflow: "hidden" }}>
                  <div style={{ background: "#2d4ac6", padding: "16px 20px", display: "flex", alignItems: "center", gap: "16px" }}>
                    {school.logoUrl && <img src={school.logoUrl} alt="logo" style={{ height: "52px", width: "52px", objectFit: "contain", background: "#fff", borderRadius: "4px", padding: "2px" }} onError={(e) => { e.target.style.display = "none"; }} />}
                    <div style={{ flex: 1 }}>
                      <div style={{ color: "#fff", fontWeight: "bold", fontSize: "16px" }}>{school.name}</div>
                      {school.address && <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "11px", marginTop: "2px" }}>{school.address}</div>}
                      {school.phone && <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "11px" }}>Ph: {school.phone}</div>}
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ color: "#fff", fontWeight: "bold", fontSize: "14px", letterSpacing: "1px" }}>PAYSLIP</div>
                      <div style={{ color: "rgba(255,255,255,0.85)", fontSize: "11px" }}>{payslip.month_label}</div>
                    </div>
                  </div>
                  <div style={{ background: "#f0f3ff", padding: "12px 20px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px 20px", fontSize: "12px" }}>
                    {[["Employee Name", payslip.employee_name], ["Bank Name", payslip.bank_name || "—"], ["Employee Code", payslip.employee_code], ["Account No", payslip.bank_accno || "—"], ["Employee Type", payslip.employee_type], ["Working Days", `${payslip.present_days} / ${payslip.total_days}`]].map(([label, value]) => (
                      <div key={label} style={{ display: "flex", gap: "8px" }}>
                        <span style={{ color: "#555", minWidth: "110px", fontWeight: "600" }}>{label}:</span>
                        <span style={{ color: "#222" }}>{value}</span>
                      </div>
                    ))}
                  </div>
                  <div style={{ padding: "16px 20px" }}>
                    <table className="table table-bordered table-sm mb-0">
                      <thead style={{ backgroundColor: "#2d4ac6" }}>
                        <tr>
                          <th style={{ color: "#fff" }}>Earnings</th><th className="text-end" style={{ color: "#fff" }}>Amount</th>
                          <th style={{ color: "#fff" }}>Deductions</th><th className="text-end" style={{ color: "#fff" }}>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          const earn = payslip.details?.filter((d) => d.component_type === "earning") || [];
                          const dedu = payslip.details?.filter((d) => d.component_type === "deduction") || [];
                          return Array.from({ length: Math.max(earn.length, dedu.length) }, (_, i) => (
                            <tr key={i}>
                              <td>{earn[i]?.component_name || ""}</td>
                              <td className="text-end">{earn[i] ? `₹ ${parseFloat(earn[i].amount).toFixed(2)}` : ""}</td>
                              <td>{dedu[i]?.component_name || ""}</td>
                              <td className="text-end">{dedu[i] ? `₹ ${parseFloat(dedu[i].amount).toFixed(2)}` : ""}</td>
                            </tr>
                          ));
                        })()}
                      </tbody>
                      <tfoot>
                        <tr style={{ background: "#e8ecff" }}>
                          <td className="fw-bold" style={{ color: "#2d4ac6" }}>Gross Salary</td>
                          <td className="text-end fw-bold" style={{ color: "#2d4ac6" }}>₹ {parseFloat(payslip.gross_salary).toFixed(2)}</td>
                          <td className="fw-bold" style={{ color: "#2d4ac6" }}>Total Deductions</td>
                          <td className="text-end fw-bold" style={{ color: "#2d4ac6" }}>₹ {parseFloat(payslip.total_deductions).toFixed(2)}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div style={{ background: "#2d4ac6", padding: "12px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ color: "#fff", fontWeight: "bold", fontSize: "14px" }}>Net Salary Payable</span>
                    <span style={{ color: "#fff", fontWeight: "bold", fontSize: "18px" }}>₹ {parseFloat(payslip.net_salary).toFixed(2)}</span>
                  </div>
                  <div style={{ padding: "8px 20px", textAlign: "center", fontSize: "10px", color: "#888", borderTop: "1px solid #dee2e6" }}>
                    This is a computer generated payslip and does not require a signature.
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <a onClick={printPayslip} className="btn btn-danger"><i className="fa fa-file-pdf-o me-1" /> Download PDF</a>
              <a onClick={() => setPayslipShow(false)} className="btn btn-secondary">Close</a>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
}
